import { DateTimeField } from '../../../../../components/Time/DateTimeField';
import { useCurrentUser } from '../../../../../services/currentUser';
import { toMoment } from '../../../../../services/time';
import { EditComponentProps, ViewComponentProps } from '../types';

export const EditSectionSendDate = ({
  value,
  onChange
}: EditComponentProps) => {
  return (
    <DateTimeField
      value={value.data.sendDate.at}
      tz={value.data.tz}
      minutesStep={10}
      onChange={(ts) =>
        onChange({
          ...value,
          data: {
            ...value.data,
            sendDate: {
              ...value.data.sendDate,
              at: ts
            }
          }
        })
      }
      disablePast
    />
  );
};

export const ViewSectionSendDate = ({ value }: ViewComponentProps) => {
  const { org } = useCurrentUser();
  return (
    <div>
      {toMoment(value.data.sendDate.at)
        .tz(value.data.tz)
        .format(`${org.dateFormats.MMDDYYYY}, hh:mm a z`)}
    </div>
  );
};
